<template>
  <div style="display: contents;">
    <div v-if="this.gmoPageStore.gmoPage" v-html="this.gmoPageStore.gmoPage"></div>
    <iframe v-if="this.gmoPageStore.gmoUrl" ref="iframe" :src="this.gmoPageStore.gmoUrl" width="100%" :height="iframeHeight" @load="updateIframeHeight()" frameborder="0" scrolling=”no”></iframe>
  </div>
</template>

<script>
import { useGmoPageStore } from '@/store/gmoPage'

export default {
  computed: {
    gmoPageStore: function () {
      return useGmoPageStore()
    },
    paymentData () {
      return this.$route.query
    }
  },
  data () {
    return {
      iframeHeight: '1000px' // 初期値設定
    }
  },
  mounted () {
    window.addEventListener('message', this.receiveMessage, false)
  },
  methods: {
    // 画面サイズとiframeのサイズを合わせる,
    updateIframeHeight () {
      this.iframeHeight = window.innerHeight + 'px'
    },
    receiveMessage (event) {
      // postMessageを受け取ったらrouterセットする
      // 許可するoriginを設定 web-apiのドメインを指定する
      console.warn('postMessage()受信')
      const domain = new URL(process.env.VUE_APP_API_URL_BASE).origin
      const allowedOrigins = [domain]
      if (!allowedOrigins.includes(event.origin)) {
        console.warn('postMessage()のoriginが許可されていないため拒否:', event.origin)
        return
      }

      if (event.data.action === 'navigateVue') {
        console.log('iframeからpostMessage()受信 Vue Routerセット:', event.data.route)
        console.log('iframeからpostMessage()受信 parameter:', event.data.params)
        // webviewのstateとpostmessageされたparamをマージする
        const mergedQuery = { ...this.paymentData, ...event.data.params }
        this.iframeVisible = false
        this.$router.push({
          name: 'V2' + event.data.route,
          query: mergedQuery
        })
      }
    }
  }
}
</script>
